<template>
  <div class="placeholder-page">
    <i class="el-icon-s-cooperation placeholder-icon"></i>
    <div class="placeholder-title">{{ pageTitle }}</div>
    <div class="placeholder-desc">功能开发中，敬请期待</div>
  </div>
</template>

<script>
export default {
  name: 'PlaceholderPage',
  computed: {
    pageTitle() {
      return this.$route.meta.title || '页面'
    }
  }
}
</script>
